import { CardState } from '@witkac/kartamiejska-shared';

export const cardStateOrder = [
  CardState[CardState.NOT_CONFIRMED],
  CardState[CardState.ORDERED],
  CardState[CardState.PREPARED_TO_PRINT],
  CardState[CardState.PRINTED],
  CardState[CardState.PREPARED],
  CardState[CardState.TRANSPORT],
  CardState[CardState.READY],
  CardState[CardState.ACTIVE],
  CardState[CardState.INACTIVE]
];

export const cardStatePermissions: Record<string, string> = {
  [CardState[CardState.NOT_CONFIRMED]]: 'CARD.ORDER_PRINT',
  [CardState[CardState.ORDERED]]: 'CARD.PREPARE_TO_PRINT',
  [CardState[CardState.PREPARED_TO_PRINT]]: 'CARD.PREPARE_TO_PRINT',
  [CardState[CardState.PRINTED]]: 'CARD.PREPARED',
  [CardState[CardState.PREPARED]]: 'CARD.TRANSPORT',
  [CardState[CardState.TRANSPORT]]: 'CARD.DELIVERED',
  [CardState[CardState.READY]]: 'CARD.COLLECT',
  [CardState[CardState.ACTIVE]]: 'CARD.ORDER_PRINT',
  [CardState[CardState.INACTIVE]]: 'CARD.DEACTIVATE'
};

export function getCardStatePermission(state: string): string {
  return cardStatePermissions[state] || 'CARD.LIST';
}
